//TODO: implement interface of this module similarly to apiService.js to migrate to this one.
import axios from 'axios';

const abmApiUrl = 'api/v1';

const apiService = axios.create({
	headers: {
		'Cache-Control': 'no-cache',
		'Pragma': 'no-cache',
		'Expires': -1,
		'Content-Type': 'application/json; charset=utf-8'
	},
	withCredentials: true
});

export const setBaseURL = url => apiService.defaults.baseURL = `${url}${abmApiUrl}`;

export default apiService;